var map = {
	"./AboutIcon.vue": 269,
	"./ChatIcon.vue": 19452,
	"./FriendsIcon.vue": 89930,
	"./GroupsIcon.vue": 23131,
	"./LogoIcon.vue": 67410,
	"./ManipulatorsIcon.vue": 86507,
	"./NewsIcon.vue": 95479,
	"./NotificationIcon.vue": 68740,
	"./PhotosIcon.vue": 52203,
	"./ProfileIcon.vue": 36835
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53201;